import {UserAccessRole} from "../../users/model/UserAccessRole";
import {ToastNotificationService} from "../../utils/ToastNotificationService";
import {UserDto} from "../../users/model/User";
import {ToastNotificationServiceName} from "../../utils/names/serviceNames";

export class UserValidationService {

    static instance = [ToastNotificationServiceName, UserValidationService];

    constructor(private toastNotificationService: ToastNotificationService) {
    }

    validateUser = (user: UserDto): boolean => {
        if (user.accessLevel == UserAccessRole.BRANCH) {
            if (user.branch == null) {
                let errorMessage = 'User Branch must be set for the user with access level BRANCH';
                this.toastNotificationService.generateErrorMessageWithDelay(errorMessage, 10000);
                return false;
            }
        }
        return true;
    };


}